module.exports = __webpack_public_path__ + "img/platform.0e92e786.jpg";